import {
  RECEIVE_VISUAL_SEARCH_FAILURE,
  RECEIVE_VISUAL_SEARCH_INPUT_IMAGE,
  RECEIVE_VISUAL_SEARCH_SUCCESS,
  REQUEST_VISUAL_SEARCH,
  RESET_VISUAL_SEARCH_INPUT_IMAGE,
  RESET_VISUAL_SEARCH_RESULTS
} from 'constants/reduxActions';
import { AppAction } from 'types/app';
import { VisualSearchAPIResponse, VisualSearchData } from 'components/VisualSearch/VisualSearchResults/visualSearchResults.types';

export interface VisualSearchResultsState {
  visualSearchData: VisualSearchData;
  visualSearchDataStatus: VisualSearchAPIResponse;
  inputImage: File | null;
}

const emptyVisualSearchData = {
  products: []
};

const initialState: VisualSearchResultsState = {
  visualSearchData: emptyVisualSearchData,
  visualSearchDataStatus: VisualSearchAPIResponse.UNKNOWN,
  inputImage: null
};

export default function visualSearch(state: VisualSearchResultsState = initialState, action: AppAction): VisualSearchResultsState {
  switch (action.type) {
    case REQUEST_VISUAL_SEARCH:
      return { ...state, visualSearchDataStatus: VisualSearchAPIResponse.FETCHING };
    case RECEIVE_VISUAL_SEARCH_SUCCESS:
      const { visualSearchData } = action;
      return { ...state, visualSearchData: visualSearchData, visualSearchDataStatus: VisualSearchAPIResponse.FETCHED };
    case RECEIVE_VISUAL_SEARCH_FAILURE:
      return { ...state, visualSearchDataStatus: VisualSearchAPIResponse.FAILED };
    case RESET_VISUAL_SEARCH_RESULTS:
      return { ...state, visualSearchData: emptyVisualSearchData, visualSearchDataStatus: VisualSearchAPIResponse.UNKNOWN };
    case RECEIVE_VISUAL_SEARCH_INPUT_IMAGE:
      const { inputImage } = action;
      return { ...state, inputImage };
    case RESET_VISUAL_SEARCH_INPUT_IMAGE:
      return { ...state, inputImage: null };
    default:
      return state;
  }
}
